exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .read-guide-line{position:fixed;width:100%;background:#000;height:8px;border-top:2px solid #ff0;border-bottom:2px solid #ff0;top:50%;z-index:10000;display:none;pointer-events:none;left:0}#wacg-wrapper .activeGuideLine{display:block}", ""]);

// exports
